import helper from '../../helpers/helper';

document.addEventListener('turbolinks:load', () => {
  const $mediaItemsNew = $('.media_items.new');
  const $mediaItemsEdit = $('.media_items.edit');

  if (
    helper.notPresent($mediaItemsNew) && helper.notPresent($mediaItemsEdit)
  ) {
    return;
  }

  ['source', 'product'].forEach((mediaItemType) => {
    $(`#${mediaItemType}_media_item_item_url`).on('change', (e) => {
      const key = window.LINKPREVIEW_API_KEY;
      const url = $(e.target).val();

      if (url.length === 0) {
        return;
      }

      const $imageField = $(`#${mediaItemType}_media_item_item_image_url`);
      const $titleField = $(`#${mediaItemType}_media_item_item_title`);
      const $descriptionField = $(`#${mediaItemType}_media_item_item_description`);
      const $linkPreviewedAtField = $(`#${mediaItemType}_media_item_link_previewed_at`);

      $('.thumb-url-tab').click();

      $.ajax({
        url: `https://api.linkpreview.net?key=${key}&q=${url}`,
        success(result) {
          $imageField.val(result.image);
          $titleField.val(result.title);
          $descriptionField.val(result.description);
          $linkPreviewedAtField.val(new Date());
        },
      });
    });
  });

  $('.thumb-file-tab').click((e) => {
    e.preventDefault();
    $('#source_media_item_item_image_url').val('');
    $('#product_media_item_item_image_url').val('');
    $('.thumb-file-tab').addClass('active');
    $('.thumb-url-tab').removeClass('active');
    $('.thumb-file-panel').removeClass('d-none');
    $('.thumb-url-panel').addClass('d-none');
  });

  $('.thumb-url-tab').click((e) => {
    e.preventDefault();
    $('#source_media_item_thumbnail_attributes_file_cloudinary').val('');
    $('#product_media_item_thumbnail_attributes_file_cloudinary').val('');
    $('.thumb-file-tab').removeClass('active');
    $('.thumb-url-tab').addClass('active');
    $('.thumb-file-panel').addClass('d-none');
    $('.thumb-url-panel').removeClass('d-none');
  });
});
